import React from 'react';
import VstComponent from './VstComponent';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import copyProps from '../utils/copy-props';
import namespaceOptions from '../utils/namespace-options';
import addClassName from '../utils/add-class-name';
import iIcon from '../images/i_icon.svg';
import errorIcon from '../images/error_icon.svg';
import { css } from 'glamor';

export default class VstInput extends VstComponent {

  componentDidMount() {
    this.renderTooltip = this.renderTooltip.bind(this);
    this._isCheckboxOrRadio = this._isCheckboxOrRadio.bind(this);
  }

  _preventDefault(e) {
    e.preventDefault();
  }

  _isCheckboxOrRadio() {
    return this.props.type === 'checkbox' || this.props.type === 'radio';
  }

  _getCSS() {
    return {
      '&:focus': {
        borderColor: this._theme(6)
      },
      '&[type="submit"]': {
        backgroundColor: this._theme(7),
        ':hover': {
          backgroundColor: this._theme(8)
        }
      }
    };
  }

  render() {
    const theme = css(this._getCSS());
    const failureId = `${this.props.id}-failure`;

    let props = addClassName(this.props, classNames('vst-input', namespaceOptions('vst', this.props.options), { failure: this.props.failure }, theme.toString()));
    props = copyProps(props, ['failure', 'tooltip', 'tooltipConf', 'options', 'label', 'ignoreLabel']);
    return (
      <div className={classNames('vst-form-group', `vst-form-group-${this.props.type}`, namespaceOptions('vst-form-group', this.props.options))}>
        {!this._isCheckboxOrRadio() && this.renderLabel()}
        {this.renderTooltip()}
        <input aria-required={this.props.required} aria-describedby={failureId} aria-invalid={!!this.props.failure} {...props} />
        {this._isCheckboxOrRadio() && this.renderLabel()}
        {this.renderFailure(failureId)}
      </div>
    );
  }

  renderLabel() {
    if (this.props.type !== 'submit' && !this.props.ignoreLabel) {
      return (
        <label className={`vst-label vst-label-${this.props.type}`} htmlFor={this.props.id}>
          {
            <span style={this.props.hideLabel ?
              {
                // https://webaim.org/techniques/css/invisiblecontent/#absolutepositioning
                position: 'absolute',
                left: '-10000px',
                top: 'auto',
                width: '1px',
                height: '1px',
                overflow: 'hidden',
              } : {}}
            >
              {this.props.label}
            </span>
          }
          {this.props.failure && this._isCheckboxOrRadio() && <span className="vst-label-icon">{errorIcon()}</span>}
        </label>
      );
    }
    return null;
  }

  renderFailure(failureId) {
    if (this.props.failure) {
      return (
        <div id={failureId} role="alert" className={classNames('vst-failure-message', { visible: this.props.failure })}>
          {this.props.failure}
        </div>
      );
    }
    return null;
  }

  renderTooltip() {
    if (this.props.tooltip) {
      return (
        <span className="vst-label-icon"
          onMouseOver={this._preventDefault}
          data-vst-tooltip-conf={this.props.tooltipConf}
          data-vst-tooltip={this.props.tooltip}
        >
          {iIcon()}
        </span>
      );
    }
    return null;
  }
}

VstInput.propTypes = {
  id: PropTypes.string.isRequired,
  ignoreLabel: PropTypes.bool,
  label: PropTypes.string,
  tooltipConf: PropTypes.string,
  failure: PropTypes.node,
  type: PropTypes.string,
  checkLabel: (props) => {
    const isValid = props.ignoreLabel || props.label;
    return !isValid && new Error('VstInput requires a label');
  },
  hideLabel: PropTypes.bool,
};

VstInput.defaultProps = {
  tooltipConf: 'multiline',
  type: 'text',
};
